export const sampleData = [
  {
    id: 1,
    startDateTime: "2024-01-15T10:00:00.000Z",
    endDateTime: "2024-01-15T11:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Team Meeting",
    description: "Discuss project updates and plan for the week.",
  },
  {
    id: 2,
    startDateTime: "2024-01-16T14:00:00.000Z",
    endDateTime: "2024-01-16T15:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Client Presentation",
    description: "Present the latest product features to the client.",
  },
  {
    id: 3,
    startDateTime: "2024-01-17T09:30:00.000Z",
    endDateTime: "2024-01-17T10:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Project Kick-off",
    description: "Kick-off meeting for a new project with the team.",
  },
  {
    id: 4,
    startDateTime: "2024-01-18T16:00:00.000Z",
    endDateTime: "2024-01-18T17:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "event",
    title: "Birthday Celebration",
    description: "Celebrate a colleague's birthday in the office.",
  },
  {
    id: 5,
    startDateTime: "2024-01-19T11:00:00.000Z",
    endDateTime: "2024-01-19T12:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Weekly Review",
    description: "Review progress and plan for the upcoming week.",
  },
  {
    id: 6,
    startDateTime: "2024-01-20T13:30:00.000Z",
    endDateTime: "2024-01-20T15:00:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Project Demo",
    description: "Demo of the new project features for stakeholders.",
  },
  {
    id: 7,
    startDateTime: "2024-01-21T10:30:00.000Z",
    endDateTime: "2024-01-21T12:00:00.000Z",
    timezone: "Asia/Kolkata",
    type: "event",
    title: "Training Workshop",
    description: "Training session for the team on new tools and techniques.",
  },
  {
    id: 8,
    startDateTime: "2024-01-22T15:30:00.000Z",
    endDateTime: "2024-01-22T17:00:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Budget Discussion",
    description: "Discuss budget allocation for the upcoming quarter.",
  },
  {
    id: 9,
    startDateTime: "2024-01-23T12:00:00.000Z",
    endDateTime: "2024-01-23T13:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "event",
    title: "Lunch with Team",
    description: "Casual team lunch to build team camaraderie.",
  },
  {
    id: 10,
    startDateTime: "2024-01-24T09:00:00.000Z",
    endDateTime: "2024-01-24T10:30:00.000Z",
    timezone: "Asia/Kolkata",
    type: "meeting",
    title: "Client Feedback Session",
    description: "Discuss client feedback and plan improvements.",
  },
];
